import { InvoiceMeta, InvoiceStatusType } from "@/types/db/invoices";

export type InvoiceForm = {
  invoice_number?: string;
  client_id: string;
  project_id: string;
  purchar_order_number?: string;
  status: InvoiceStatusType;
  meta_data?: InvoiceMeta;
};

export type InvoicePayload = {
  invoice: InvoiceForm;
};
